import React, { useState, useEffect, useCallback, useMemo } from "react";
import jalaali from "jalaali-js";
import { Col, Button, Modal, Row } from "react-bootstrap";
import _ from "lodash";
import Select from "react-select";
import { useForm, Controller, FormProvider } from "react-hook-form";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import HistoryIcon from "@mui/icons-material/History";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiAmusementServiceReserveItemGroup from "../../../core/api/api.amusementServiceReserveItemGroup";
import ApiAmusementServiceReserveItem from "../../../core/api/api.amusementServiceReserveItem";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import CloseIcon from "@mui/icons-material/CloseRounded";
import AddIcon from "@mui/icons-material/Add";
import ChangesHistoryModal from "./components/ChangesHistoryModal";
import CreateReserveFormDate from "./components/CreateReserveFormDate";
import CreateAllDates from "./components/CreateAllDates";
import AddDescriptionModal from "../AmusementServiceReservationForm/components/AddDescriptionModal";
import SelectComponent from "../_Components/ReactSelectComponent";

const AmusementServiceReservationForm2 = () => {
  const [services, setServices] = useState([]);
  const [service, setService] = useState();
  const [reserveItems, setReserveItems] = useState([]);
  const [reserveItemGroups, setReserveItemGroups] = useState([]);
  const methods = useForm();
  const [showModalAddDescription, setShowModalAddDescription] = useState(false);
  const [reserveDescriptions, setReserveDescriptions] = useState([]);
  const [dates, setDates] = useState([]);
  const [reserveDetail, setReserveDetail] = useState({ service: null, reserveDetailJson: null });
  const [newDescriptionId, setNewDescriptionId] = useState()
  const [modalNameDate, setModalNameDate] = useState("");
  const [showModalChangesHistory, setShowModalChangesHistory] = useState(false);
  const [periodDates, setPeriodDates] = useState({ startDate: "", endDate: "", allDates: [], newDates: [] });
  const [periodDatesFilters, setPeriodDatesFilters] = useState({
    allDays: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  });

  const patternDate = methods.watch("patternDate");
  const selectedService = methods.watch("selectedService");
  const filter_Saturday = methods.watch(`filter_Saturday`);
  const filter_Sunday = methods.watch(`filter_Sunday`);
  const filter_Monday = methods.watch(`filter_Monday`);
  const filter_Tuesday = methods.watch(`filter_Tuesday`);
  const filter_Wednesday = methods.watch(`filter_Wednesday`);
  const filter_Thursday = methods.watch(`filter_Thursday`);
  const filter_Friday = methods.watch(`filter_Friday`);
  // Fetch all services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await ApiAmusementService.getAllServices();
        if (!_.isEmpty(data)) {
          setServices(data);
        }
      } catch { }
    };
    fetchServices();
  }, []);
  const closeModalAddDescription = useCallback(() => setShowModalAddDescription(false), []);

  useEffect(() => {
    const today = new Date();
    const thirtyDaysFromNow = new Date(today);
    thirtyDaysFromNow.setDate(today.getDate() + 30);
    const toJalaali = (date) => {
      const jDate = jalaali.toJalaali(date);
      return `${jDate.jy}/${("0" + jDate.jm).slice(-2)}/${("0" + jDate.jd).slice(-2)}`;
    };
    const formattedToday = toJalaali(today);
    const formattedThirtyDaysFromNow = toJalaali(thirtyDaysFromNow);
    methods.setValue("patternDate", formattedToday);
    methods.setValue("dateTimeStart", formattedToday);
    methods.setValue("dateTimeEnd", formattedThirtyDaysFromNow);
  }, []);
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  // جدا کردن ساعت و دقیقه از مقدار زمان
  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    return `${hours}: ${minutes}`;
  };

  const onSubmit = async (data) => {
    let patternDate = "";
    let datePatternDate = methods.getValues("patternDate");
    if (datePatternDate !== null && typeof datePatternDate === "object") {
      patternDate =
        datePatternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
        datePatternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
        datePatternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
    } else {
      patternDate = datePatternDate.replaceAll("/", "");
    }
    if (patternDate == "" || _.isNull(data[`${patternDate}-IA`])) {
      await SwalMessage({
        title: "لطفا ابتدا تاریخ الگو را انتخاب نمایید",
        iSsuccess: false,
      });
    } else if (service == undefined || _.isNull(service)) {
      await SwalMessage({
        title: "لطفا ابتدا سرویس را انتخاب کنید",
        iSsuccess: false,
      });
    } else {
      var patternAmusementReserveItems = {
        d: patternDate,
        dIA: data[`${patternDate}-IA`], // DateIsActive
        dDesId: data[`${patternDate}-Des`]?.value, // DateDescriptionId
        g: reserveItemGroups.map((group) => ({
          // reserveItemGroups
          gId: group.id, // groupId
          gID: data[`${patternDate}-${group.id}-ID`], // GroupIsDisplay
          gIA: data[`${patternDate}-${group.id}-IA`], // GroupIsActive
          gDesId: data[`${patternDate}-${group.id}-Des`]?.value, // GroupDescriptionId
          i: reserveItems.map((item) => ({
            // reserveItems
            iId: item.id, // itemId
            iID: data[`${patternDate}-${group.id}-${item.id}-ID`], // ItemIsDisplay
            iIA: data[`${patternDate}-${group.id}-${item.id}-IA`], // ItemIsActive
            iC: data[`${patternDate}-${group.id}-${item.id}-C`], // ItemCapacity
            iIFC: data[`${patternDate}-${group.id}-${item.id}-IFC`], // ItemIsFullCapacity
            iMinC: data[`${patternDate}-${group.id}-${item.id}-MinC`], // MinimumReserveCountPerDay
          })),
        })),
      };
      const amusementReserveItems = [];
      periodDates.allDates.map((date) => {
        const nameDate = date.year + date.month + date.day;
        if (data[`d-${nameDate}`]) {
          let patternAmusementReserveItemsCopy = _.cloneDeep(patternAmusementReserveItems);
          patternAmusementReserveItemsCopy.d = nameDate;
          amusementReserveItems.push(patternAmusementReserveItemsCopy);
        }
      });
      if (amusementReserveItems.length == 0) {
        await SwalMessage({
          title: "حداقل یک تاریخ باید انتخاب شود",
          iSsuccess: false,
        });
        return;
      }

      const jsonAmusementReserveItems = JSON.stringify(amusementReserveItems);
      try {
        const response = await ApiAmusementService.updateAmusementReserveDetail({
          id: service,
          ReserveDetail_V2: jsonAmusementReserveItems,
          beOverwritten: false,
        });
        if (response?.succeeded) {
          SwalMessage({
            title: "تغییرات با موفقیت اعمال شد.",
            iSsuccess: true,
          });
        } else {
          await SwalMessage({
            title: response?.message ? response?.message : "خطا در روند اجرای برنامه!",
            iSsuccess: false,
          });
        }
      } catch (error) {
        await SwalMessage({
          title: "خطا در روند اجرای برنامه!!",
          iSsuccess: false,
        });
      }
    }
  };
  const onSubmitViewItems = async (data) => {
    if (_.isUndefined(patternDate) || _.isUndefined(selectedService)) {
      SwalMessage({
        title: _.isUndefined(selectedService) ? " تفریح مورد نظر را انتخاب کنید." : "تاریخ الگو را انتخاب کنید ",
        iSsuccess: false,
        timer: 5000,
      });
    } else {
      let patternDate = "";
      if (data?.patternDate && typeof data.patternDate === "object") {
        patternDate =
          data.patternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
          data.patternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
          data.patternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
      } else {
        patternDate = data.patternDate.replaceAll("/", "");
      }
      await getSelectedServiceData(patternDate, patternDate);
      const newDefaults = {};
      Object.keys(methods.getValues()).forEach((fieldName) => {
        if (fieldName.startsWith(patternDate)) {
          newDefaults[fieldName] = ""; // یا مقدار جدید دلخواهت
        }
      });
    }
  };

  const getSelectedServiceData = async (startDate, endDate) => {
    if (!!patternDate && !!selectedService) {
      const response =
        _.isEmpty(startDate) || _.isEmpty(endDate)
          ? await ApiAmusementService.getReserveDetails({ id: selectedService })
          : await ApiAmusementService.getReserveDetails({
            id: selectedService,
            startDate: startDate,
            endDate: endDate,
          });
      const descriptionsObject = JSON.parse(response.reserveDetail_V2Descriptions);
      const formattedDescriptions = !_.isNil(descriptionsObject)
        ? descriptionsObject?.map((desc) => ({
          value: desc.id,
          label: desc.desc,
        }))
        : [];
      setReserveDescriptions(formattedDescriptions);
      setService(selectedService);
      createDates(response.fullDateTimeDtos);
      // تنظیم مقادیر ورودی‌ها با داده‌های ذخیره‌شده
      const reserveDetailObject = JSON.parse(response.reserveDetail_V2);
      setReserveDetail({ service: selectedService, reserveDetailJson: reserveDetailObject });
      setReserveItems([]);
      setReserveItemGroups([]);
      const amusementServiceReserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(selectedService);
      if (!_.isEmpty(amusementServiceReserveItems)) {
        const activeItems = amusementServiceReserveItems.filter(a => a.isActive);
        setReserveItems(activeItems);
      }
      const itemGroupResponse = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(selectedService);
      if (!_.isEmpty(itemGroupResponse)) {
        const activeItemGroupResponse = itemGroupResponse.filter(a => a.isActive);
        setReserveItemGroups(activeItemGroupResponse);
      }
    }
    else
      setReserveItemGroups([])
  };

  const values = useMemo(() => methods.getValues(), [methods]); // تمام فیلدهای ثبت‌شده

  const createDates = (allDates) => {
    const days = [];
    allDates.map((item) => {
      const nameDate = item.year + item.month + item.day;
      days.push({ formattedDate: item.date, nameDate, persianDayOfWeek: item.persianDayOfWeek });
    });
    setDates(days);

    resetAllFormInputs();
  };
  const handleModalAddDescriptionFormSubmit = async (data) => {
    const { description } = data;
    if (description.trim()) {
      const newOption = {
        value: `new- ${description}`,
        label: description,
      };

      setShowModalAddDescription(false);

      let reserveDescriptions2 = reserveDescriptions.filter((desc) => desc.label !== "افزودن توضیح جدید");
      reserveDescriptions2 = reserveDescriptions2.map((desc) => ({
        id: desc.value,
        desc: desc.label,
      }));

      const newId = reserveDescriptions2.length
        ? (parseInt(reserveDescriptions2[reserveDescriptions2.length - 1].id) + 1).toString()
        : "1";

      const newEntry = { id: newId, desc: description };

      reserveDescriptions2 = [...reserveDescriptions2, newEntry];

      const jsonUpdatedDescriptions = JSON.stringify(reserveDescriptions2);

      try {
        const response = await ApiAmusementService.updateAmusementReserveDetail({
          id: service,
          ReserveDetail_V2Descriptions: jsonUpdatedDescriptions,
        });
        if (response.succeeded) {
          Swal.fire({
            title: response.message,
            icon: response.succeeded ? "success" : "error",
            focusCancel: true
          });
          const updatedReserveDescriptions = reserveDescriptions2.map((desc) => ({
            value: desc.id,
            label: desc.desc,
          }));
          setReserveDescriptions(updatedReserveDescriptions);
          setNewDescriptionId(newId);
        }
      } catch (error) {
      }
    }
  };
  const showHistoryModal = async () => {
    setShowModalChangesHistory(true);
  };

  useEffect(() => {
    if (periodDates.startDate != "" && periodDates.endDate != "") {
      const fetch_GetDatesBetweenTwoDates = async () => {
        try {
          const AllPeroidDates = await ApiAmusementService.getDatesBetweenTwoDates({
            startDate: periodDates.startDate,
            endDate: periodDates.endDate,
          });
          const newDates = _.differenceBy(AllPeroidDates, periodDates.allDates, "date");
          setPeriodDates({ ...periodDates, allDates: AllPeroidDates, newDates: newDates });
        } catch (error) {
        }
      };
      fetch_GetDatesBetweenTwoDates();

      Object.keys(values).forEach((fieldName) => {
        if (fieldName.startsWith("d-")) {
          // methods.resetField(fieldName);
        }
      });
    }
  }, [periodDates.startDate, periodDates.endDate]);
  useEffect(() => {
    periodDates.newDates.map(function (date) {
      const nameDate = date.year + date.month + date.day;
      methods.resetField(`d-${nameDate}`);
    });
    periodDates.allDates.map(function (date) {
      const nameDate = date.year + date.month + date.day;
      if (date.persianDayOfWeek == "شنبه" && filter_Saturday) methods.setValue(`d-${nameDate}`, filter_Saturday);
      if (date.persianDayOfWeek == "یکشنبه" && filter_Sunday) methods.setValue(`d-${nameDate}`, filter_Sunday);
      if (date.persianDayOfWeek == "دوشنبه" && filter_Monday) methods.setValue(`d-${nameDate}`, filter_Monday);
      if (date.persianDayOfWeek == "سه شنبه" && filter_Tuesday) methods.setValue(`d-${nameDate}`, filter_Tuesday);
      if (date.persianDayOfWeek == "چهارشنبه" && filter_Wednesday) methods.setValue(`d-${nameDate}`, filter_Wednesday);
      if (date.persianDayOfWeek == "پنج شنبه" && filter_Thursday) methods.setValue(`d-${nameDate}`, filter_Thursday);
      if (date.persianDayOfWeek == "جمعه" && filter_Friday) methods.setValue(`d-${nameDate}`, filter_Friday);
    });
  }, [periodDates.allDates]);
  useEffect(() => {
    if (
      !filter_Saturday ||
      !filter_Sunday ||
      !filter_Monday ||
      !filter_Tuesday ||
      !filter_Wednesday ||
      !filter_Thursday ||
      !filter_Friday
    ) {
      methods.setValue("filter_AllDays", false);
      setPeriodDatesFilters({ ...periodDatesFilters, allDays: false });
    }
    if (
      filter_Saturday &&
      filter_Sunday &&
      filter_Monday &&
      filter_Tuesday &&
      filter_Wednesday &&
      filter_Thursday &&
      filter_Friday
    ) {
      methods.setValue("filter_AllDays", true);
      setPeriodDatesFilters({ ...periodDatesFilters, allDays: true });
    }
    periodDates.allDates.map(function (date) {
      const nameDate = date.year + date.month + date.day;
      if (date.persianDayOfWeek == "شنبه" && !_.isNil(periodDatesFilters.saturday))
        methods.setValue(`d-${nameDate}`, periodDatesFilters.saturday);
      if (date.persianDayOfWeek == "یکشنبه" && !_.isNil(periodDatesFilters.sunday))
        methods.setValue(`d-${nameDate}`, periodDatesFilters.sunday);
      if (date.persianDayOfWeek == "دوشنبه" && !_.isNil(periodDatesFilters.monday))
        methods.setValue(`d-${nameDate}`, periodDatesFilters.monday);
      if (date.persianDayOfWeek == "سه شنبه" && !_.isNil(periodDatesFilters.tuesday))
        methods.setValue(`d-${nameDate}`, periodDatesFilters.tuesday);
      if (date.persianDayOfWeek == "چهارشنبه" && !_.isNil(periodDatesFilters.wednesday))
        methods.setValue(`d-${nameDate}`, periodDatesFilters.wednesday);
      if (date.persianDayOfWeek == "پنج شنبه" && !_.isNil(periodDatesFilters.thursday))
        methods.setValue(`d-${nameDate}`, periodDatesFilters.thursday);
      if (date.persianDayOfWeek == "جمعه" && !_.isNil(periodDatesFilters.friday))
        methods.setValue(`d-${nameDate}`, periodDatesFilters.friday);
    });
  }, [
    periodDatesFilters.saturday,
    periodDatesFilters.sunday,
    periodDatesFilters.monday,
    periodDatesFilters.tuesday,
    periodDatesFilters.wednesday,
    periodDatesFilters.thursday,
    periodDatesFilters.friday,
  ]);

  const getDateFromDatePicket = (date) => {
    if (!!date?.year) {
      return (
        date.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
        date.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
        date.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false })
      );
    } else return null;
  };
  useEffect(() => {
    (async () => {
      if (selectedService != 0) {
        let dateTimeStart = methods.getValues("dateTimeStart");
        let dateTimeEnd = methods.getValues("dateTimeEnd");
        let datePatternDate = methods.getValues("patternDate");
        let startDate = "";
        let endDate = "";
        let patternDate = "";
        if (datePatternDate !== null && typeof datePatternDate === "object") {
          patternDate =
            datePatternDate.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            datePatternDate.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            datePatternDate.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          patternDate = datePatternDate?.replaceAll("/", "");
        }

        if (dateTimeStart !== null && typeof dateTimeStart === "object") {
          startDate =
            dateTimeStart.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            dateTimeStart.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            dateTimeStart.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          startDate = dateTimeStart.replaceAll("/", "");
        }
        if (dateTimeEnd !== null && typeof dateTimeEnd === "object") {
          endDate =
            dateTimeEnd.year.toLocaleString("en-US", { minimumIntegerDigits: 4, useGrouping: false }) +
            dateTimeEnd.month.number.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
            dateTimeEnd.day.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false });
        } else {
          endDate = dateTimeEnd.replaceAll("/", "");
        }
        await getSelectedServiceData(patternDate, patternDate);
        resetAllFormInputs();
      }
    })();
  }, [selectedService, patternDate]);

  const resetAllFormInputs = () => {
    //Reset all date checked box field for show new default value
    dates.forEach(({ formattedDate, nameDate }) => {
      methods.resetField(`${nameDate}-IA`);
      methods.resetField(`${nameDate}-ID`);
      methods.resetField(`${nameDate}-Des`);

      reserveItemGroups.forEach((group) => {
        methods.resetField(`${nameDate}-${group.id}-ID`);
        methods.resetField(`${nameDate}-${group.id}-IA`);
        methods.resetField(`${nameDate}-${group.id}-Des`);

        reserveItems.forEach((item) => {
          methods.resetField(`${nameDate}-${group.id}-${item.id}-ID`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-IA`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-C`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-IFC`);
          methods.resetField(`${nameDate}-${group.id}-${item.id}-MinC`);
        });
      });
    });
  };
  const deleteAmusementReserveDetail = async () => {
    if (selectedService) {
      Swal.fire({
        title: "عملیات حذف فرم رزرو",
        text: "از حذف فرم رزرو اطمینان دارید؟",
        icon: "question",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "بله",
        denyButtonText: "خیر",
        cancelButtonText: "انصراف",
        customClass: {
          actions: "my-actions",
          cancelButton: "order-1 right-gap btn btn-secondary ",
          confirmButton: "order-2 btn btn-success px-5",
          denyButton: "order-3 btn btn-danger px-5",
        },
        focusCancel: true
      }).then((result) => {
        if (result.isConfirmed) {
          // (async () => {
          try {
            const responsePromise = ApiAmusementService.deleteAmusementReserveDetail(selectedService);
            responsePromise.then((response) => {
              if (response.succeeded == true) {
                SwalMessage({
                  title: response.message,
                  iSsuccess: true,
                });
                resetAllFormInputs();
                methods.handleSubmit(onSubmitViewItems)();
              }
            });
          } catch (error) {
          }
          //}
          //)
        }
      });
    } else {
      SwalMessage({ title: "ابتدا تفریح مورد نظر را انتخاب کنید.", iSsuccess: false });
    }
  };

  return (
    <div className="card-body pt-3 pb-0 border-top px-0">
      <FormProvider {...methods}>
        <form noValidate autoComplete="off" className="mt-3" onSubmit={methods.handleSubmit(onSubmitViewItems)}>
          <Row>
            <Col xs="12" xl="9">
              <Row className="mb-3 align-items-center">
                <Col xs="12" sm="6" md xl="6">
                  <Controller
                    name="patternDate"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                      <ShamsiDatePicker
                        className="mt-5"
                        value={value}
                        onChange={onChange}
                        placeholder="انتخاب فرم الگو"
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="6" md xl="6">
                  <Controller
                    name="selectedService"
                    control={methods.control}
                    render={({ field }) => (
                      <SelectComponent
                        name="service"
                        className="mt-5 w-100"
                        variant="outlined"
                        placeholder="انتخاب سرویس"
                        options={services?.map((item) => ({
                          value: item.id,
                          label: item.name,
                          type: "service",
                        }))}
                        noLabel
                        value={
                          services
                            .map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))
                            .find((option) => option.value === field.value) || null
                        }
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption?.value ?? null);
                        }}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
        <form noValidate autoComplete="off" className="mt-3" onSubmit={methods.handleSubmit(onSubmit)}>
          <Row>
            <Col xs="12" xl="auto" className="text-md-center d-md-flex align-items-start mt-1">
              <Button type="submit" color="primary">
                <SaveIcon className="mr-1" />
              ذخیره
            </Button>
              <Button variant="danger" type="button" className=" mx-2" onClick={deleteAmusementReserveDetail}>
                <DeleteIcon className="mr-1" />
              حذف فرم رزرو
            </Button>
              <Button variant="info" type="button" className="mx-2" color="success" onClick={showHistoryModal}>
                <HistoryIcon className="mr-1" />
              تاریخچه تغییرات
            </Button>
            </Col>
          </Row>
          <Row>
            <Col xs="12" xl="9">
              <Row className="mt-4">
                {dates.map((date, index) => (
                  <CreateReserveFormDate
                    key={date + index}
                    selectedService={selectedService}
                    reserveDetail={reserveDetail}
                    date={date}
                    reserveDescriptions={reserveDescriptions}
                    reserveItemGroups={reserveItemGroups}
                    reserveItems={reserveItems}
                    formatTime={formatTime}
                    setModalNameDate={setModalNameDate}
                    setShowModalAddDescription={setShowModalAddDescription}
                  />
                ))}
              </Row>
            </Col>
            <Col xs="12" xl="9" className="mt-5">
              <Row>
                <Col xs="12" sm="6" md xl="6">
                  <Controller
                    name="dateStart"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                      <ShamsiDatePicker
                        className="mt-5"
                        value={value}
                        onChange={(val) => {
                          onChange(val);
                          setPeriodDates({ ...periodDates, startDate: getDateFromDatePicket(val) });
                        }}
                        placeholder="از تاریخ"
                      />
                    )}
                  />
                </Col>
                <Col xs="12" sm="6" md xl="6">
                  <Controller
                    name="dateEnd"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => {
                      return (
                        <ShamsiDatePicker
                          className="mt-5"
                          value={value}
                          onChange={(val) => {
                            onChange(val);
                            setPeriodDates({ ...periodDates, endDate: getDateFromDatePicket(val) });
                          }}
                          placeholder="تا تاریخ"
                        />
                      );
                    }}
                  />
                </Col>
              </Row>
              <Row className="mb-3 mt-5 text-small">
                <Col xs="3" md="auto" className="d-flex align-items-center">
                  <Controller
                    name="filter_AllDays"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        name={field.name}
                        id="filter_AllDays"
                        checked={field.value ?? false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters({
                            ...periodDatesFilters,
                            allDays: isChecked,
                            saturday: isChecked,
                            sunday: isChecked,
                            monday: isChecked,
                            tuesday: isChecked,
                            wednesday: isChecked,
                            thursday: isChecked,
                            friday: isChecked,
                          });
                          methods.setValue(`filter_Saturday`, isChecked);
                          methods.setValue(`filter_Sunday`, isChecked);
                          methods.setValue(`filter_Monday`, isChecked);
                          methods.setValue(`filter_Tuesday`, isChecked);
                          methods.setValue(`filter_Wednesday`, isChecked);
                          methods.setValue(`filter_Thursday`, isChecked);
                          methods.setValue(`filter_Friday`, isChecked);
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_AllDays" className="user-select-none me-1" style={{ margin: 0 }}>همه روزها</label>
                </Col>
                <Col xs="3" md="auto" className="d-flex align-items-center">
                  <Controller
                    name="filter_Saturday"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        name={field.name}
                        id="filter_Saturday"
                        checked={field.value ?? false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: isChecked,
                            sunday: null,
                            monday: null,
                            tuesday: null,
                            wednesday: null,
                            thursday: null,
                            friday: null,
                          }));
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_Saturday" className="user-select-none me-1" style={{ margin: 0 }}>شنبه</label>
                </Col>
                <Col xs="3" md="auto" className=" d-flex align-items-center">
                  <Controller
                    name="filter_Sunday"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        name={field.name}
                        checked={field.value ?? false}
                        id="filter_Sunday"
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: null,
                            sunday: isChecked,
                            monday: null,
                            tuesday: null,
                            wednesday: null,
                            thursday: null,
                            friday: null,
                          }));
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_Sunday" className="user-select-none me-1" style={{ margin: 0 }}>یکشنبه</label>
                </Col>
                <Col xs="3" md="auto" className=" d-flex align-items-center">
                  <Controller
                    name="filter_Monday"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        name={field.name}
                        checked={field.value ?? false}
                        id="filter_Monday"
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: null,
                            sunday: null,
                            monday: isChecked,
                            tuesday: null,
                            wednesday: null,
                            thursday: null,
                            friday: null,
                          }));
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_Monday" className="user-select-none me-1" style={{ margin: 0 }}>دوشنبه</label>
                </Col>
                <Col xs="3" md="auto" className="d-flex align-items-center">
                  <Controller
                    name="filter_Tuesday"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        name={field.name}
                        checked={field.value ?? false}
                        id="filter_Tuesday"
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: null,
                            sunday: null,
                            monday: null,
                            tuesday: isChecked,
                            wednesday: null,
                            thursday: null,
                            friday: null,
                          }));
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_Tuesday" className="user-select-none me-1" style={{ margin: 0 }}>سه شنبه</label>
                </Col>
                <Col xs="3" md="auto" className=" d-flex align-items-center">
                  <Controller
                    name="filter_Wednesday"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        id="filter_Wednesday"
                        name={field.name}
                        checked={field.value ?? false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: null,
                            sunday: null,
                            monday: null,
                            tuesday: null,
                            wednesday: isChecked,
                            thursday: null,
                            friday: null,
                          }));
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_Wednesday" className="user-select-none me-1" style={{ margin: 0 }}>چهارشنبه</label>
                </Col>
                <Col xs="3" md="auto" className=" d-flex align-items-center">
                  <Controller
                    name="filter_Thursday"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        name={field.name}
                        checked={field.value ?? false}
                        id="filter_Thursday"
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: null,
                            sunday: null,
                            monday: null,
                            tuesday: null,
                            wednesday: null,
                            thursday: isChecked,
                            friday: null,
                          }));
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_Thursday" className="user-select-none me-1" style={{ margin: 0 }}>پنجشنبه</label>
                </Col>
                <Col xs="3" md="auto" className=" d-flex align-items-center">
                  <Controller
                    name="filter_Friday"
                    control={methods.control}
                    render={({ field }) => (
                      <input
                        type="checkbox"
                        name={field.name}
                        id="filter_Friday"
                        checked={field.value ?? false}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked);
                          setPeriodDatesFilters((prev) => ({
                            ...prev,
                            saturday: null,
                            sunday: null,
                            monday: null,
                            tuesday: null,
                            wednesday: null,
                            thursday: null,
                            friday: isChecked,
                          }));
                        }}
                      />
                    )}
                  />
                  <label htmlFor="filter_Friday" className="user-select-none me-1" style={{ margin: 0 }}>جمعه</label>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs="12">
                  {periodDates?.allDates && periodDates.allDates.length != 0 && <CreateAllDates dates={periodDates.allDates} setPeriodDatesFilters={setPeriodDatesFilters} />}
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
        {showModalAddDescription &&
          <AddDescriptionModal
            showModalAddDescription={showModalAddDescription}
            handleModalClose={closeModalAddDescription}
            modalNameDate={modalNameDate}
            setReserveDescriptions={setReserveDescriptions}
            service={service}
            reserveDescriptions={reserveDescriptions}
            setShowModalAddDescription={setShowModalAddDescription}
          />}
      </FormProvider>
      {showModalChangesHistory && (
        <ChangesHistoryModal
          showModalChangesHistory={showModalChangesHistory}
          setShowModalChangesHistory={setShowModalChangesHistory}
          selectedServiceId={selectedService}
        />
      )}
    </div>
  );
};

export default AmusementServiceReservationForm2;
